import { type DealFormData, dealFormField } from '@openx/types/deal.ts';
import { fromZonedTime } from 'date-fns-tz';
import { useMemo, useRef } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

export const useDealStartDateCheck = ({ isEdit }: { isEdit: boolean }) => {
  const { control } = useFormContext<DealFormData>();

  const observableStartDate = useWatch({ control, name: dealFormField.START_DATE });

  const initialStartDate = useRef(observableStartDate);

  const isStartDateOneHourAhead = useMemo(() => {
    // in create mode we don't don't block any fields
    if (!isEdit) return true;

    if (!initialStartDate.current) return false;

    const startDate = fromZonedTime(initialStartDate.current, 'UTC');

    const now = new Date();
    const oneHourFromNow = new Date(now.getTime() + 60 * 60 * 1000);

    return startDate >= oneHourFromNow;
  }, [isEdit]);

  return { isStartDateOneHourAhead };
};
